export interface UserInputFileMetadata {
	status: string;
	organization: string;
	id: string;
	filename: string;
	createdBy: string;
	uploadedBy: string;
	createdAt: string;
	updatedAt: string;
	storageService: string;
	contentHash: string;
	operator: string;
}

export interface SpaceObject {
	cosparId: string;
	noradId: number;
	name: string;
	operator: string;
}

export interface OemData {
	id: string;
	operator: string;
	spaceObject: SpaceObject;
	startDate: string;
	endDate: string;
	creationDate: string;
	sourceOfInformation: string;
	category: string;
	orbitFile: string;
	plotFiles: string;
	parentUserInput: UserInputFileMetadata;
	opmUserInput: UserInputFileMetadata;
	organization: string;
}

export type LogSeverity = "INFO" | "WARN" | "ERROR" ;

export interface InputLog {
	id: string;
	timestamp: string;
	author: string;
	severity: LogSeverity;
	message: string;
}

export interface InputWithOem extends UserInputFileMetadata {
	linkedOEM: OemData;
	logs: InputLog[];
}

export type InputsApiResponse = InputWithOem[];

export const InputsState = {
  ACTIVE: "ACTIVE",
  ABOUT_TO_EXPIRE: "ABOUT_TO_EXPIRE",
  EXPIRED: "EXPIRED",
  TEST: "TEST"
} as const;

export type InputsStateType = typeof InputsState[keyof typeof InputsState];
